module.exports = __webpack_public_path__ + "img/ordTNiac2.ebfc7f49.jpg";